export default __webpack_public_path__ + "static/media/Rectangle_30.2eaba0ce.png";